import * as React from 'react';

import { NewReviewModalReview } from '../../../components/NewReviewModal';
import { UserInfoContainer } from './UserInfoContainer';
import { ProsContainer } from './ProsContainer';
import { ConsContainer } from './ConsContainer';
import { ProsAndCons } from '../../../components/NewReviewModal/parts/NewReviewModalReview/parts/ProsAndCons';
import { AnonymousContainer } from './AnonymousContainer';

export const ReviewContainer = () => {
  return (
    <NewReviewModalReview>
      <UserInfoContainer />

      <ProsAndCons
        title="Расскажите про ЖК"
        subtitle="Заполните хотя бы один из пунктов"
        pros={<ProsContainer />}
        cons={<ConsContainer />}
      />

      <AnonymousContainer />
    </NewReviewModalReview>
  );
};
